import React from 'react';
import { ProviderFactory } from 'shared/providers/provider-factory';
import { useGetEnvironmentConfiguration } from 'shared/hooks/query-hooks/use-get-environment-configuration';
import { StateError } from 'shared/components/common/state/State';
import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { TFeatureFlagContext } from './feature-flag-provider.types';

const [Provider, useFeatureFlagProvider] = ProviderFactory<TFeatureFlagContext>(
  'FeatureFlagContext can only be accessed within FeatureFlagProvider'
);

const FeatureFlagProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const environmentConfigurationQuery = useGetEnvironmentConfiguration();

  if (environmentConfigurationQuery.status !== 'success') {
    return (
      <RenderUnsettledUI
        renderLoading={<SmallLoader />}
        renderError={(error) => <SmallError error={error} />}
        data={environmentConfigurationQuery}
      />
    );
  }

  const featureFlags = environmentConfigurationQuery.data.backend.featureFlags;
  const { allowFreelancerEmploymentType, allowTempWorkerEmploymentType } = featureFlags;
  if (!allowFreelancerEmploymentType && !allowTempWorkerEmploymentType) {
    return <StateError error={new Error('Er zijn geen werkvormen beschikbaar')} />;
  }

  return <Provider value={featureFlags}>{children}</Provider>;
};

const useFeatureFlagContext = () => {
  const featureFlags = useFeatureFlagProvider();

  return featureFlags;
};

export { FeatureFlagProvider, useFeatureFlagContext };
